import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { Trans } from "react-i18next";

type Props = {
	i18nKey: string;
	values: Record<string, string>;
};

export const EmphasisNote: FC<Props> = ({ i18nKey, values }) => {
	const theme = useTheme();

	return (
		<Typography variant="note" tabular mt={theme.spacingTokens.md}>
			<Trans
				i18nKey={i18nKey}
				values={values}
				components={{
					b: (
						<Typography
							component="span"
							variant="captionStrong"
							color="text.primary"
							tabular
						/>
					),
				}}
			/>
		</Typography>
	);
};
